import type { TrackEventCategory, TrackValue } from './interface'

export function trackEvent(category: TrackEventCategory, event: TrackValue): void {
  window._paq.push(['trackEvent', category, event.action || '', event.name || '', event.value])
}

// 设置自定义连接
export function setCustomerUrl(url: string) {
  window._paq.push(['setCustomUrl', url])
}

// 设置用户id
export function setUserId(userId: string) {
  window._paq.push(['setUserId', userId])
}

// 设置页面标题
export function trackPageView(title?: string) {
  if (title) {
    window._paq.push(['trackPageView', title])
    return
  }
  window._paq.push(['trackPageView'])
}

// 重置用户信息
export function resetUserId() {
  window._paq.push(['resetUserId'])
}

// 重置页面访问
export function appendToTrackingUrl(visit = '') {
  window._paq.push(['appendToTrackingUrl', visit])
}

// 退出登录通知matomo重置用户访问
export function logoutResetMatomo() {
  resetUserId()
  appendToTrackingUrl('new_visit=1')
  trackPageView()
  appendToTrackingUrl()
}
